export function addHeroPersona(hero){
    return{
        type:'ADD_HERO_PERSONA',
        payload:hero
    }
}